<div class="file-loading">
  <mat-progress-spinner [mode]="progressValue > 0 ? 'determinate' : 'indeterminate'" class="background grey-spinner"
                        [diameter]="200"
                        [value]="100">
  </mat-progress-spinner>
  <mat-progress-spinner mode="determinate" [ngClass]="status === 'error' ? 'error-spinner' : ''"
                        [diameter]="200"
                        [value]="progressValue">
  </mat-progress-spinner>
  <div class="file-loading-spinner-inside">{{insideLabel}}%</div>
  <div class="file-loading-spinner-label">
    <app-span3dot [text]="nameLabel" maxWidth="200"></app-span3dot>
    <span>{{statusLabel}}</span>
  </div>
</div>
